import { FdStaking } from "../types/fd_staking";
import _idl from "./fd_staking.json";

const idl = _idl as any as FdStaking;

export default idl;
